<template>
<v-dialog v-model="photoViewer.show" max-width="700px">
    <v-card>
        <v-card-title>
            <span>{{photoViewer.title}}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="photoViewer.show = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="text--primary">
            <v-img :src="photoViewer.url" :alt="photoViewer.title">
            </v-img>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text right @click="photoViewer.show = false">
                Zamknij
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        photoViewer: {
            type: Object,
            required: true
        },
    },
};
</script>

<style>
</style>
